<span @fadeIn [class]="panelClass" class="flex items-center p-10 border border-solid rounded gap-x-10">
  @if (showPanelIcon) {
    <i class="flex-none material-icons mi-18" [class]="iconClass">{{panelIcon}}</i>
  }
  <span class="text-sm">
    <ng-content></ng-content>
  </span>
</span>